import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MonthView from "../../../Shared/DateHeader/MonthView";
import {
  showModal,
  hideModal,
  getMonthTimesheetData,
  resetsaveTimesheetMessage,
} from "../../../../Actions";
import { format, isFuture,isToday } from "date-fns";
import { dateFormat } from "../../../../Api/Utils/ReuseableFunctions";

class TechnicianMonthView extends Component {
  constructor(props) {
    super(props);
    this.payload = {
      ssoId: props.ssoId,
      workshopLocation: props.branchId,
      role: "Technician",
      year: "",
      month: "",
      action: "",
    };
    this.state = {
      currentDate: undefined,
    };
    this.openDayTimeModal = this.openDayTimeModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  previousMonth = () => {
    this.payload.year = this.props.monthData.year;
    this.payload.month = format(this.state.currentDate, "M");
    this.payload.action = "prev";
    this.props.getMonthTimesheet(this.payload);
  };

  nextMonth = () => {
    this.payload.year = this.props.monthData.year;
    this.payload.month = format(this.state.currentDate, "M");
    this.payload.action = "next";
    this.props.getMonthTimesheet(this.payload);
  };

  componentDidMount() {
    this.props.getMonthTimesheet(this.payload);
  }

  componentDidUpdate(nextProps) {
    if (this.props.monthData !== nextProps.monthData) {
      const currentDate = dateFormat(
        this.props.monthData.otherDetailsResponseList[0].timesheetDate
      );
      this.setState({
        currentDate: currentDate,
      });
    }

    if (
      this.props.popUpMessage !== void 0 &&
      this.props.popUpMessage.type === "Timesheet Saved Successfully" &&
      this.props.popUpMessage.message.errorCd === "SUCCESS"
    ) {
      this.payload.year = this.props.monthData.year;
      this.payload.month = format(this.state.currentDate, "M");
      this.payload.action = "";
      this.props.getMonthTimesheet(this.payload);
      this.props.resetsaveTimesheetMessage();
    }
  }
  openDayTimeModal(data) {
    if (!isFuture(data.dayVal) && !isToday(data.dayVal)) {
      let dataNew = JSON.stringify(data);
      dataNew = JSON.parse(dataNew);
      dataNew.breakCal = this.props.security.enableBreaksCal === "Y";
      dataNew.showMinInt = this.props.security.showMintInt === "Y" || this.props.security.enableBreaksCal === "Y";
      this.props.showModal(
        {
          open: true,
          data: dataNew,
          closeModal: this.closeModal,
        },
        "Technician/PopUp/EditTime/index"
      );
    }
  }

  closeModal(event) {
    this.props.hideModal();
  }

  render() {
    return (
      <>
        <MonthView
          openDayDetails={this.openDayTimeModal}
          techssoID={this.props.ssoId}
          previousMonth={this.previousMonth}
          nextMonth={this.nextMonth}
          date={(data) => {
            this.setState({ currentDate: data });
          }}
        />
      </>
    );
  }
}

const mapStateToProps = ({
  auth,
  monthData,
  saveTechnicianTimesheet,
  fetchTimesheetSecurity,
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    monthData: monthData.payload,
    userDefault: auth.user.defaultProfile,
    popUpMessage: saveTechnicianTimesheet,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    security: fetchTimesheetSecurity.securityList,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch(hideModal()),
  showModal: (modalProps, template) => {
    dispatch(showModal({ modalProps, template }));
  },
  getMonthTimesheet: (payload) => dispatch(getMonthTimesheetData(payload)),
  resetsaveTimesheetMessage: () => dispatch(resetsaveTimesheetMessage()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TechnicianMonthView)
);
